import { useEffect } from 'react';
import { isMotionValue } from './utils/is-motion-value.js';

function useOnChange(value, callback) {
    useEffect(function () {
        if (isMotionValue(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    useEffect(function () {
        var subscriptions = values.map(function (value) { return value.onChange(handler); });
        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
    });
}

export { useMultiOnChange, useOnChange };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/value/use-on-change.js
// module id = 65
// module chunks = 0